export const PROJECT_TYPES = ['behance', 'dribbble'];
